.Button {
    padding: 12px 30px;
    border-radius: 24px;
    text-align: center;
    font-family: var(--tips-font-family);
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.5px;
    width: 100%;
    border: none;
    cursor: pointer;
    background-color: var(--tips-color-light);
    color: var(--tips-color-tnemec-black);
}
